import {ReactElement, useContext} from 'react';

import {IconHeader, JobDetailsIcon} from '../IconHeader/IconHeader';

import {LanguageContext} from '../../../../../contexts/LanguageContext/LanguageContext';
import {orangeColors} from '../../../../../layouts/theme/designSystem';
import {Benefit} from '../../../../company/profile/types';

interface Props {
  // Header for benefit section
  children: ReactElement;
  textColor: string;
  benefits: Benefit[];
}
export const BenefitsSection = ({children, benefits, textColor}: Props) => {
  const lang = useContext(LanguageContext);
  return (
    <>
      {children}
      {benefits.map((benefit) => {
        return (
          <IconHeader
            key={benefit.resourceId}
            textColor={textColor}
            iconColor={orangeColors[900]}
            icon={JobDetailsIcon.Check}
            text={benefit.labels[lang] || ''}
          />
        );
      })}
    </>
  );
};
